<!-- ===== HERO — diptyque des deux services ===== -->
<section class="hero">
  <div class="hero-inner">
    <header class="hero-head">
      <h1 class="hero-title">{{ "HOME.HERO.TITLE" | productionTranslate }}</h1>
      <p class="hero-subtitle">{{ "HOME.HERO.SUBTITLE" | productionTranslate }}</p>
    </header>

    <!-- Deux panneaux de service égaux ; le panneau VM reste derrière le feature flag
         (flag OFF en prod : le panneau envoi occupe toute la largeur) -->
    <div class="hero-panels" [class.hero-panels-solo]="!showVirtualMailbox">
      <article class="panel panel-ship">
        <h2 class="panel-title">{{ "HOME.PANEL_SHIP.TITLE" | productionTranslate }}</h2>
        <p class="panel-desc">{{ "HOME.PANEL_SHIP.DESC" | productionTranslate }}</p>
        <div class="panel-actions">
          <div class="panel-buttons">
            <a routerLink="/new-shipment" class="btn-panel btn-panel-ship">
              {{ "HOME.PANEL_SHIP.CTA" | productionTranslate }}
              <i class="fas fa-arrow-right" aria-hidden="true"></i>
            </a>
            <a routerLink="/price-calculator" class="btn-panel btn-panel-secondary">
              <i class="fas fa-calculator" aria-hidden="true"></i>
              {{ "HOME.PANEL_SHIP.LINK_PRICE" | productionTranslate }}
            </a>
            <a routerLink="/pickup-points" class="btn-panel btn-panel-secondary">
              <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
              {{ "HOME.PANEL_SHIP.LINK_PICKUP" | productionTranslate }}
            </a>
          </div>
          <nav class="panel-links" [attr.aria-label]="'HOME.PANEL_SHIP.TITLE' | productionTranslate">
            <a routerLink="/info/contactus">
              <i class="fas fa-headset" aria-hidden="true"></i>
              {{ "HOME.PANEL_SHIP.LINK_HELP" | productionTranslate }}
            </a>
          </nav>
        </div>
      </article>

      <article class="panel panel-vm" *ngIf="showVirtualMailbox">
        <span class="panel-badge">{{ "HOME.PANEL_VM.BADGE" | productionTranslate }}</span>
        <h2 class="panel-title">{{ "HOME.PANEL_VM.TITLE" | productionTranslate }}</h2>
        <p class="panel-desc">{{ "HOME.PANEL_VM.DESC" | productionTranslate }}</p>
        <div class="panel-actions">
          <div class="panel-buttons">
            <a routerLink="/vm/register" class="btn-panel btn-panel-vm">
              {{ "HOME.PANEL_VM.CTA" | productionTranslate }}
              <i class="fas fa-arrow-right" aria-hidden="true"></i>
            </a>
            <a routerLink="/vm/info" class="btn-panel btn-panel-secondary">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
              {{ "HOME.PANEL_VM.LINK_INFO" | productionTranslate }}
            </a>
          </div>
          <nav class="panel-links" [attr.aria-label]="'HOME.PANEL_VM.TITLE' | productionTranslate">
            <a routerLink="/portal/vm/dashboard">
              <i class="fas fa-user" aria-hidden="true"></i>
              {{ "HOME.PANEL_VM.LINK_DASHBOARD" | productionTranslate }}
            </a>
          </nav>
        </div>
      </article>
    </div>

    <!-- Barre de suivi façon étiquette d'expédition -->
    <form class="trackbar" [formGroup]="homeForm" (ngSubmit)="onSubmit()" id="tracking">
      <label class="trackbar-label" for="trackingID">
        <i class="fas fa-search" aria-hidden="true"></i>
        {{ "HOME.TRACKBAR.LABEL" | productionTranslate }}
      </label>
      <input
        id="trackingID"
        type="text"
        formControlName="trackingID"
        class="trackbar-input"
        placeholder="{{ 'HOME.TRACKBAR.PLACEHOLDER' | productionTranslate }}"
        autocomplete="off">
      <button type="submit" class="trackbar-btn">
        {{ "HOME.TRACKBAR.BUTTON" | productionTranslate }}
      </button>
    </form>
  </div>
</section>

<!-- ===== MARKETING BANNERS (#568 — campagnes bannières via public_banners) ===== -->
<section class="container">
  <app-marketing-banner placement="homepage"></app-marketing-banner>
</section>

<!-- ===== PROMOTIONS DYNAMIQUES (Firestore) — style coupon détachable ===== -->
<section class="promo-section" *ngIf="homepagePromotions$ | async as promotions">
  <div class="section-inner" *ngIf="promotions.length">
    <div class="coupon" *ngFor="let promo of promotions; let i = index">
      <div class="coupon-main">
        <p class="coupon-badge">
          <i class="fas fa-gift" aria-hidden="true"></i>
          {{ (promo.type === 'manual' ? 'HOME.PROMO.BADGE_CODE' : 'HOME.PROMO.BADGE_OFFER') | productionTranslate }}
        </p>
        <h3 class="coupon-title">{{ promo.title }}</h3>
        <p class="coupon-desc">{{ promo.description || ('HOME.PROMO.FALLBACK_DESC' | productionTranslate) }}</p>
        <p class="coupon-validity">
          <i class="fas fa-clock" aria-hidden="true"></i>
          {{ "HOME.PROMO.VALID_UNTIL" | productionTranslate }} {{ promo.endDate | date:'dd/MM/yyyy' }}
        </p>
      </div>
      <div class="coupon-stub">
        <p class="coupon-amount">
          {{ promo.typeOfComputing === 'percentage' ? '−' + promo.amount + '%' : '−' + promo.amount + '€' }}
        </p>
        <p class="coupon-code-label">{{ "HOME.PROMO.CODE_LABEL" | productionTranslate }}</p>
        <p class="coupon-code" [id]="'promoCode' + i">{{ promo.code }}</p>
        <button class="btn-copy-code" type="button"
                (click)="copyPromoCodeDynamic(promo.code, i)"
                [title]="'HOME.PROMO.COPY' | productionTranslate">
          <i class="fas fa-copy" aria-hidden="true"></i>
          {{ "HOME.PROMO.COPY" | productionTranslate }}
        </button>
        <a [routerLink]="['/new-shipment']" [queryParams]="{promo: promo.code}" class="coupon-claim">
          {{ "HOME.PROMO.CLAIM" | productionTranslate }}
          <i class="fas fa-arrow-right" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- ===== COMMENT ÇA MARCHE — deux chemins, un seul corridor ===== -->
<section class="how-section">
  <div class="section-inner">
    <header class="section-head">
      <p class="eyebrow">{{ "HOME.HOW.EYEBROW" | productionTranslate }}</p>
      <h2 class="section-title">{{ "HOME.HOW.TITLE" | productionTranslate }}</h2>
    </header>

    <div class="how-paths" [class.how-paths-solo]="!showVirtualMailbox">
      <div class="path path-ship">
        <p class="path-label">
          <i class="fas fa-box" aria-hidden="true"></i>
          {{ "HOME.HOW.SHIP_LABEL" | productionTranslate }}
        </p>
        <ol class="path-steps">
          <li>
            <span class="step-num" aria-hidden="true">01</span>
            <div>
              <h3>{{ "HOME.HOW.SHIP_STEP1_TITLE" | productionTranslate }}</h3>
              <p>{{ "HOME.HOW.SHIP_STEP1_DESC" | productionTranslate }}</p>
            </div>
          </li>
          <li>
            <span class="step-num" aria-hidden="true">02</span>
            <div>
              <h3>{{ "HOME.HOW.SHIP_STEP2_TITLE" | productionTranslate }}</h3>
              <p>{{ "HOME.HOW.SHIP_STEP2_DESC" | productionTranslate }}</p>
            </div>
          </li>
          <li>
            <span class="step-num" aria-hidden="true">03</span>
            <div>
              <h3>{{ "HOME.HOW.SHIP_STEP3_TITLE" | productionTranslate }}</h3>
              <p>{{ "HOME.HOW.SHIP_STEP3_DESC" | productionTranslate }}</p>
            </div>
          </li>
        </ol>
      </div>

      <div class="path path-vm" *ngIf="showVirtualMailbox">
        <p class="path-label">
          <i class="fas fa-shopping-cart" aria-hidden="true"></i>
          {{ "HOME.HOW.VM_LABEL" | productionTranslate }}
        </p>
        <ol class="path-steps">
          <li>
            <span class="step-num" aria-hidden="true">01</span>
            <div>
              <h3>{{ "HOME.HOW.VM_STEP1_TITLE" | productionTranslate }}</h3>
              <p>{{ "HOME.HOW.VM_STEP1_DESC" | productionTranslate }}</p>
            </div>
          </li>
          <li>
            <span class="step-num" aria-hidden="true">02</span>
            <div>
              <h3>{{ "HOME.HOW.VM_STEP2_TITLE" | productionTranslate }}</h3>
              <p>{{ "HOME.HOW.VM_STEP2_DESC" | productionTranslate }}</p>
            </div>
          </li>
          <li>
            <span class="step-num" aria-hidden="true">03</span>
            <div>
              <h3>{{ "HOME.HOW.VM_STEP3_TITLE" | productionTranslate }}</h3>
              <p>{{ "HOME.HOW.VM_STEP3_DESC" | productionTranslate }}</p>
            </div>
          </li>
        </ol>
      </div>
    </div>

    <!-- Le corridor commun : signature de la page -->
    <div class="corridor">
      <ol class="corridor-route">
        <li>
          <span class="corridor-dot" aria-hidden="true"><i class="fas fa-warehouse"></i></span>
          <span class="corridor-stop">{{ "HOME.CORRIDOR.STOP1" | productionTranslate }}</span>
        </li>
        <li>
          <span class="corridor-dot" aria-hidden="true"><i class="fas fa-tag"></i></span>
          <span class="corridor-stop">{{ "HOME.CORRIDOR.STOP2" | productionTranslate }}</span>
        </li>
        <li>
          <span class="corridor-dot" aria-hidden="true"><i class="fas fa-plane"></i></span>
          <span class="corridor-stop">{{ "HOME.CORRIDOR.STOP3" | productionTranslate }}</span>
        </li>
        <li>
          <span class="corridor-dot" aria-hidden="true"><i class="fas fa-id-card"></i></span>
          <span class="corridor-stop">{{ "HOME.CORRIDOR.STOP4" | productionTranslate }}</span>
        </li>
      </ol>
      <p class="corridor-note">
        {{ "HOME.CORRIDOR.NOTE" | productionTranslate }}
        <code>BF-BE01-123456-2</code>
      </p>
    </div>
  </div>
</section>

<!-- ===== GARANTIES — communes aux deux services ===== -->
<section class="guarantees-section">
  <div class="section-inner">
    <header class="section-head">
      <h2 class="section-title">{{ "HOME.GUARANTEES.TITLE" | productionTranslate }}</h2>
      <p class="section-subtitle">{{ "HOME.GUARANTEES.SUBTITLE" | productionTranslate }}</p>
    </header>
    <div class="guarantees-grid">
      <div class="guarantee">
        <i class="fas fa-plane" aria-hidden="true"></i>
        <h3>{{ "HOME.GUARANTEES.G1_TITLE" | productionTranslate }}</h3>
        <!-- #1560 — le nombre de pays ouverts est un PARAMÈTRE, pas un mot du
             texte traduit : il est dérivé du catalogue des pays d'origine
             (reference_data/enabled_countries → défauts du code, #956), donc
             juste en permanence, y compris au prochain pays ouvert. -->
        <p>{{ "HOME.GUARANTEES.G1_DESC" | productionTranslate:openOriginCountries }}</p>
      </div>
      <div class="guarantee">
        <i class="fas fa-bell" aria-hidden="true"></i>
        <h3>{{ "HOME.GUARANTEES.G2_TITLE" | productionTranslate }}</h3>
        <p>{{ "HOME.GUARANTEES.G2_DESC" | productionTranslate }}</p>
      </div>
      <div class="guarantee">
        <i class="fas fa-box-open" aria-hidden="true"></i>
        <h3>{{ "HOME.GUARANTEES.G3_TITLE" | productionTranslate }}</h3>
        <p>{{ "HOME.GUARANTEES.G3_DESC" | productionTranslate }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== OUTILS — la grille tarifaire (envoi) et l'adresse belge (VM) ===== -->
<section class="tools-section">
  <div class="section-inner">
    <div class="tools-grid" [class.tools-grid-solo]="!showVirtualMailbox">
      <div class="tool-card tool-pricing">
        <p class="eyebrow">{{ "HOME.TOOLS_PRICING.EYEBROW" | productionTranslate }}</p>
        <h2 class="tool-title">{{ "HOME.TOOLS_PRICING.TITLE" | productionTranslate }}</h2>
        <p class="tool-desc">{{ "HOME.TOOLS_PRICING.DESC" | productionTranslate }}</p>
        <p class="tool-heavy-note">
          <i class="fas fa-weight-hanging" aria-hidden="true"></i>
          {{ "HOME.TOOLS_PRICING.HEAVY_NOTE" | productionTranslate }}
        </p>
        <div class="tool-actions">
          <a routerLink="/tarifs" class="btn-tool">
            <i class="fas fa-table" aria-hidden="true"></i>
            {{ "HOME.TOOLS_PRICING.CTA" | productionTranslate }}
          </a>
          <p class="tool-note">
            <i class="fas fa-download" aria-hidden="true"></i>
            {{ "HOME.TOOLS_PRICING.PDF_NOTE" | productionTranslate }}
          </p>
        </div>
      </div>

      <div class="tool-card tool-vm" *ngIf="showVirtualMailbox">
        <p class="eyebrow">{{ "HOME.TOOLS_VM.EYEBROW" | productionTranslate }}</p>
        <p class="tool-desc">{{ "HOME.TOOLS_VM.DESC" | productionTranslate }}</p>
        <!-- #1563 — l'avertissement de facturation. Il ne porte AUCUN chiffre :
             le tarif et le délai vivent dans les conditions d'utilisation
             (section 20), qui les dérivent de reference_data/vm_storage. Un
             montant recopié ici serait une seconde source de vérité. -->
        <p class="tool-desc tool-desc-notice">
          {{ "HOME.TOOLS_VM.INVOICE_NOTICE" | productionTranslate }}
        </p>
        <div class="vm-address-card">
          <p class="vm-address-head">{{ "HOME.TOOLS_VM.MOCKUP_TITLE" | productionTranslate }}</p>
          <!-- #1561 — l'adresse vient de reference_data/warehouse_address (défauts
               codés en repli), jamais des fichiers de langue : l'entrepôt existe
               à un seul endroit et un déménagement suit tout seul. Le nom et le
               code, eux, restent un GABARIT — publier la vraie adresse à côté
               d'un code destinataire recopiable enverrait des colis réels sous
               un code qui n'appartient à personne (file des non identifiés). -->
          <p class="vm-address-body">
            <strong>{{ "HOME.TOOLS_VM.ADDRESS_NAME" | productionTranslate }}</strong><br>
            {{ warehouseAddress.company }}<br>
            {{ warehouseAddress.street }}<br>
            {{ "HOME.TOOLS_VM.ADDRESS_LOCALITY" | productionTranslate:warehouseAddress }}
          </p>
          <p class="vm-address-code-note">
            {{ "HOME.TOOLS_VM.CODE_NOTE" | productionTranslate }}
          </p>
          <p class="vm-address-hint">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
            {{ "HOME.TOOLS_VM.HINT" | productionTranslate }}
          </p>
        </div>
        <div class="tool-actions">
          <a routerLink="/vm/register" class="btn-tool btn-tool-vm">
            {{ "HOME.TOOLS_VM.CTA" | productionTranslate }}
            <i class="fas fa-arrow-right" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== CTA FINAL — dual ===== -->
<section class="final-section">
  <div class="section-inner">
    <h2 class="final-title">{{ "HOME.CTA_FINAL.TITLE" | productionTranslate }}</h2>
    <div class="final-actions">
      <a routerLink="/new-shipment" class="btn-final btn-final-ship">
        <i class="fas fa-box" aria-hidden="true"></i>
        {{ "HOME.CTA_FINAL.BTN_SHIP" | productionTranslate }}
      </a>
      <a routerLink="/vm/register" class="btn-final btn-final-vm" *ngIf="showVirtualMailbox">
        <i class="fas fa-envelope-open-text" aria-hidden="true"></i>
        {{ "HOME.CTA_FINAL.BTN_VM" | productionTranslate }}
      </a>
    </div>
  </div>
</section>
